import { message } from "antd";

const getPopupContainer = () => document.querySelector(".fullscreen-enabled") || document.body;

export const successMsg = (content) => {
  message.config({getContainer: getPopupContainer});
  message.success({ content: content });
};

export const errorMsg = (content, duration = 5) => {
  message.config({getContainer: getPopupContainer});
  message.error({ content, duration });
};

export const warningMsg = (content, duration = 5) => {
  message.config({getContainer: getPopupContainer});
  message.warning({ content, duration });
};
